import { render, staticRenderFns } from "./ButtonMicrosoftLogin.vue?vue&type=template&id=6e9c353d&scoped=true"
import script from "./ButtonMicrosoftLogin.vue?vue&type=script&lang=js"
export * from "./ButtonMicrosoftLogin.vue?vue&type=script&lang=js"
import style0 from "./ButtonMicrosoftLogin.vue?vue&type=style&index=0&id=6e9c353d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9c353d",
  null
  
)

export default component.exports